function startTimer(release_date, identifier) {
  
  // set the date we're counting down to
  var target_date = new Date(release_date).getTime();
  var now = new Date();
  
  if (target_date - now > 0) {
    $('#event-registration_form').html('<div class="text-center"><h1>Coming Soon<br><small id="countdown"></small></h1></div>');
    $('#btn-register_form > h2').html('Coming Soon');
     
    // variables for time units
    var days, hours, minutes, seconds;
     
    // get tag element
    var countdown = document.getElementById(identifier);
     
    // update the tag with id "countdown" every 1 second
    setInterval(function () {
     
        // find the amount of "seconds" between now and target
        var current_date = new Date().getTime();
        var seconds_left = (target_date - current_date) / 1000;
     
        // do some time calculations
        days = parseInt(seconds_left / 86400);
        seconds_left = seconds_left % 86400;
         
        hours = parseInt(seconds_left / 3600);
        seconds_left = seconds_left % 3600;
         
        minutes = parseInt(seconds_left / 60);
        seconds = parseInt(seconds_left % 60);
         
        // format countdown string + set tag value
        countdown.innerHTML = "Going on sale in " + days + "d, " + hours + "h, "
        + minutes + "m, " + seconds + "s";  
     
    }, 1000);
  }
}